__turbopack_context__.v({
  "calloutWrapper": "BlockHeroVideo-module-scss-module__F85nfa__calloutWrapper",
  "flushBottom": "BlockHeroVideo-module-scss-module__F85nfa__flushBottom",
  "inner": "BlockHeroVideo-module-scss-module__F85nfa__inner",
  "root": "BlockHeroVideo-module-scss-module__F85nfa__root",
});
